'use client';

import React from 'react'

const AppDescription = () => {
    return (
        <div className="max-w-4xl mx-auto mt-10 p-6 bg-white rounded-xl shadow text-gray-800 text-base">
            <h2 className="text-2xl font-bold mb-2">Darbo laiko kalendorius</h2>
            <p className="mb-2">
                Darbo laiko kalendorius – interaktyvi programa, skirta pažymėti darbo dienas ir stebėti darbo valandas bei šventes per metus. Kalendoriuje galite matyti visų mėnesių dienas viename lange arba atidaryti detalų mėnesio vaizdą.
            </p>
            <p className="mb-4">
                Sistema leidžia pažymėti bet kurias datas, kurias norite skaičiuoti kaip darbo dienas. Ji automatiškai atpažįsta valstybines šventes, savaitgalius ir koreguoja darbo valandas pagal pasirinktos darbo savaitės režimą.
            </p>

            <h3 className="text-lg font-semibold mb-2">Pagrindinės funkcijos</h3>
            <ul className="list-disc pl-6 mb-4">
                <li>Metinė peržiūra: viename lange matomi visi metų mėnesiai, leidžiant greitai įvertinti darbo dienas ir valandas.</li>
                <li>Mėnesinė peržiūra: paspaudus mėnesį, atidaromas išplėstas kalendorius su dienų numeracija ir detalėmis.</li>
                <li>Šventinių dienų žymėjimas: valstybės šventės rodomos rožine spalva.</li>
                <li>Datos žymėjimas: galite pažymėti datas, kurias norite įtraukti į darbo dienų ir valandų skaičiavimą.</li>
                <li>Darbo laiko skaičiavimas:
                    <ul className="list-disc pl-6">
                        <li>Skaičiuojamos pažymėtos darbo dienos per mėnesį, ketvirtį ir metus.</li>
                        <li>Darbo valandos apskaičiuojamos pagal pasirinktą darbo savaitės režimą (5 arba 6 dienų darbo savaitę).</li>
                        <li>Trumpesnės darbo dienos prieš šventes – darbo laikas sumažinamas 1 valanda.</li>
                    </ul>
                </li>
                <li>Paieška pagal metus: galima rasti bet kuriuos metus tarp 2020 ir 2050 ir peržiūrėti jų kalendorių.</li>
                <li>Responsyvus dizainas: veikia tiek kompiuteriuose, tiek mobiliuosiuose įrenginiuose.</li>
            </ul>

            <h3 className="text-lg font-semibold mb-2">Išmanus darbo dienų ir valandų skaičiavimas</h3>
            <ul className="list-disc pl-6 mb-4">
                <li>Darbo dienos – tik pažymėtos dienos, atmetus savaitgalius ir valstybines šventes.</li>
                <li>Darbo valandos – apskaičiuojamos automatiškai pagal pasirinktą savaitės režimą ir darbo dienos trukmę.</li>
                <li>Trumpos dienos – prieš šventes darbo laikas sumažinamas 1 valanda.</li>
                <li>Pažymėtų datų santrauka – pateikiamas tikslus pažymėtų darbo dienų ir darbo valandų skaičius.</li>
            </ul>

            <h3 className="text-lg font-semibold mb-2">Papildomos funkcijos ir nustatymai</h3>
            <ul className="list-disc pl-6 mb-2">
                <li>Metų keitimas nuo 2020 iki 2050</li>
                <li>Laikotarpio, kuriame norima suskaičiuoti darbo dienas ir valandas, pažymėjimas.</li>
                <li>Galimybė matyti ir 5 ir 6 darbo dienų duomenis.</li>
            </ul>
        </div>
    )
}

export default AppDescription;
